import { render, staticRenderFns } from "./control-wander.vue?vue&type=template&id=bef42530&scoped=true&"
import script from "./control-wander.vue?vue&type=script&lang=ts&"
export * from "./control-wander.vue?vue&type=script&lang=ts&"
import style0 from "./control-wander.vue?vue&type=style&index=0&id=bef42530&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef42530",
  null
  
)

export default component.exports